module.exports = __webpack_public_path__ + "static/img/banner_1.1403ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_1.png
// module id = k8r9
// module chunks = 2